<script>
    import DefaultApp from '../defaultApp';

    export default {
        props: {
            api: String,
            title: String,
            description: String,
            generalErrorTxt: String,
            extraAmount: Number,
            extraDescription: String,
            textOnly: Boolean
        },
        data() {
            return {
                ...DefaultApp.data(),
                amount: 0
            }
        },
        methods: {
            ...DefaultApp.methods
        },
        async mounted() {
            if (!this.extraAmount && !this.extraDescription) {
                let response = await this.fetchData({}, this.api, 'get');
                if (response.status === 200) {
                    this.amount = response.data;
                }
            }
        }
    }
</script>

<template>
    <span v-if="textOnly" v-html="description.replace('{{totalAmount}}', toEuro(amount,true))"></span>
    <div class="box" v-else>
        <h3 class="title is-3 mb-2" v-if="!extraAmount && !extraDescription">{{ title }}</h3>
        <p class="form-error has-text-danger" v-if="generalError">
            <i class="fa-solid fa-warning"></i> {{ generalErrorTxt }}
        </p>
        <table class="mb-0 is-fullwidth table" v-else>
            <tbody>
                <tr v-if="extraAmount && extraDescription">
                    <td class="is-size-8 p-0 has-text-weight-bold">{{ extraDescription }}</td>
                    <td class="is-nowrap pl-2 p-0" align="right" valign="bottom">{{ toEuro(extraAmount,true) }}</td>
                </tr>
                <tr v-else>
                    <td class="is-size-8 p-0">{{ description }}</td>
                    <td class="is-nowrap pl-2 p-0" align="right" valign="bottom">{{ toEuro(amount,true) }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
